import { render, staticRenderFns } from "./Homedetails.vue?vue&type=template&id=8f35328c&scoped=true&"
import script from "./Homedetails.vue?vue&type=script&lang=js&"
export * from "./Homedetails.vue?vue&type=script&lang=js&"
import style0 from "./Homedetails.vue?vue&type=style&index=0&id=8f35328c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f35328c",
  null
  
)

export default component.exports